// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ContractResumeController = function ($scope, $routeParams, $location, $http, Contract, ProductInfo,
    ContractCancellationPreview, ContractTimeDetails, PUtill, ContractPauseService, DatepickerUtils) {
    
    const resumeDateEnum = Object.freeze({
        "Immediately": "Immediately",
        "Later": "Later"
    });

    $scope.saveClicked = false;
    $scope.resumeOption = resumeDateEnum.Immediately;
    $scope.resumeDate = null;

    $scope.changeDate = function () {
        if ($scope.resumeOption === resumeDateEnum.Immediately)
            $scope.resumeDate = null;
        else
            $scope.resumeDate = DatepickerUtils.toBerlinMidnightTime(new Date());
    }

    let productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({ contractId: $routeParams.contractId }, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = productInfo.PlanGroupById($scope.plan.PlanGroupId);

            let planVariant = productInfo.PlanVariantById($scope.contract.PlanVariantId);
            let periodEnd = $scope.contract.CurrentPhase.Type === 'Trial' ? planVariant.ContractPeriod : planVariant.LaterContractPeriod;
            $scope.contractPeriodEnd = PUtill.addPeriod(periodEnd, $scope.contract.CurrentPhase.StartDate);
        });
    });

    $scope.resumeContract = function () {
        if ($scope.saveClicked) return;
        $scope.saveClicked = true;
        ContractPauseService.resume($routeParams.contractId, null, $scope.resumeDate).then(function () {
            $location.path("/contracts/" + $routeParams.contractId);
        }, function () {
            $scope.saveClicked = false;
        });
    }
};
ContractResumeController.$inject = [
    '$scope', '$routeParams', '$location', '$http', 'Contract', 'ProductInfo', 'ContractCancellationPreview',
    'ContractTimeDetails', 'PUtill', 'ContractPauseService', 'DatepickerUtils'];
